<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2023-05-18 17:58:19
 * @LastEditTime: 2026-04-14 19:44:26
 * @LastEditors: ranli
-->
<script setup>
import { setPubParams } from 'dad-h5-common-js'
import { getRequestHeader } from './utils/requestheader'
import { useStore } from '@/stores'
import ShareHost from '@/components/share/ShareHost.vue'
// 公共参数
import tokenInfo from './config'
import { removeLoading } from '@/utils/index'
import { thirdLogin } from '@/api/index.js'
// 是否是开发环境
const isDev = import.meta.env.DEV
const _Store = useStore()
/**
 * 应用是否准备就绪
 */
const isReady = ref(false)
/**
 * 屏幕头部高度
 */
const ScreenHeaderHeight = computed(() => 0)
/**
 * 进入页面
 * @description: 进入页面时，获取公共参数和用户信息
 */
const enterPage = async () => {
  const search = window.location.search
  // 开发环境下，直接设置公共参数
  if (isDev) {
    setPubParams(tokenInfo)
    await _Store.SET_P_D(tokenInfo)
    enterApp()
    return
  }

  // 生产环境下，从app获取公共参数
  let params = null
  if (search) {
    // 动态获取所有参数
    params = Object.fromEntries(new URLSearchParams(search))

    // 缓存
    localStorage.setItem('APP_PARAMS', JSON.stringify(params))
    await _Store.SET_P_D(params)

    // 清空 URL
    const cleanUrl = window.location.origin + window.location.pathname
    window.history.replaceState({}, '', cleanUrl)
  } else {
    // 兜底：用缓存
    const cache = localStorage.getItem('APP_PARAMS')
    params = cache ? JSON.parse(cache) : null
  }
  const p_params = params
  const cleanUrl = window.location.origin + window.location.pathname
  window.history.replaceState({}, '', cleanUrl)

  if (p_params) {
    console.log('p_params');

    setPubParams(p_params)
  } else {
    console.log('no p_params');
    const p_params = await getRequestHeader()
    setPubParams(p_params)
  }


  await _Store.SET_P_D(p_params)
  enterApp()
}
/**
 * 进入应用
 * @description: 进入应用时，移除loading
 */
const enterApp = async () => {
  if (isDev) {
    const res = await thirdLogin()
    _Store.SET_PARAMS(res.resultData)
  }
  removeLoading()
  isReady.value = true
  _Store.GET_USERINFO()
  _Store.REFRESH_BALANCE()
}
onMounted(() => {
  enterPage()
})
</script>

<template>
  <van-config-provider>
    <div :style="{
      '--screen-header-height': ScreenHeaderHeight + 'px',
    }">
      <div v-if="isReady" class="cricket-app-inner">
        <router-view />
        <ShareHost />
      </div>
    </div>
  </van-config-provider>
</template>

<style lang="less">
/* global.less */
@import '~/css/public.less';
</style>
